import {Choice} from 'platform/components';

import {useGetFinancingFieldsQuery} from '@dms/api/core';
import {FinancialProductType} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface FinancingFieldPickerProps extends TestIdProps {
  financialProductType: FinancialProductType;
  isDisabled: boolean;
  onInsert: (token: string) => void;
}

// Inserts a `{{KEY}}` data-field token; the BE substitutes the vehicle's value when rendering.
export function FinancingFieldPicker(props: FinancingFieldPickerProps) {
  const {data: fields, isLoading} = useGetFinancingFieldsQuery({
    financialProductType: props.financialProductType,
  });

  return (
    <Choice<string>
      label={i18n.t('entity.promoPhotos.composition.labels.insertField')}
      placeholder={i18n.t('entity.promoPhotos.composition.labels.insertFieldPlaceholder')}
      options={(fields ?? []).map((field) => ({value: field.key, label: field.label}))}
      value={null}
      isLoading={isLoading}
      isDisabled={props.isDisabled}
      isNotClearable
      onChange={(key) => typeof key === 'string' && props.onInsert(`{{${key}}}`)}
      data-testid={suffixTestId('choice', props)}
    />
  );
}
